<template>
  <div>
    <div v-if="!redeemNowVisible && !pointsRules">
      <el-card shadow="never" class="myTeam_card">
        <div slot="header" class="clearfix">
          <div class="desciconLarge"></div>
          <span class="font18">我的积分</span>
        </div>
        <div class="assets_top_box">
          <div class="assets_top_left">
            <el-image :src="avatar" class="assets-avatar">
              <div slot="error">
                <img src="@/assets/img/avatar.png" class="assets-avatar" />
              </div>
            </el-image>
            <div style="margin-left: 30px">
              <div class="assets_name" :class="userInfo.isFrozen === 1 ? 'gary' : '' ">{{moneyInfo.pointBalance || 0}}</div>
              <div class="assets_subname">可用积分</div>
            </div>
          </div>
          <div class="assets_top_right">
            <el-button @click="lookRules" icon="el-icon-info" type="primary" class="assets_btn">查看积分规则</el-button>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" style="margin: 30px 0">
        <div slot="header" class="clearfix">
          <div class="desciconLarge"></div>
          <span class="font18">积分兑换</span>
          <el-select
            v-model="querySearch.pointRange"
            placeholder="请选择"
            style="width: 120px;margin-left: 15px;"
            @change="handleFilterChange"
            size="small"
          >
            <el-option label="全部" value="0,99999"></el-option>
            <el-option label="5千以下" value="0,5000"></el-option>
            <el-option label="5千～1万" value="5000,10000"></el-option>
            <el-option label="1万以上" value="10000,99999"></el-option>
          </el-select>
        </div>
        <div class="materialList" ref="materialList">
          <el-empty v-if="intergraList.length == 0" description="暂无礼品" style="height: 200px"></el-empty>
          <div class="custom-flex-container" v-else>
            <div
              class="custom-flex-item"
              v-for="(i, index) in intergraList"
              :key="i + index + 'a'"
            >
              <div class="integral_equip_list">
                  <el-image
                    :src="i.pcPic || '../../assets/img/morentupian.png'"
                    class="intergraImg"
                  >
                    <div slot="error">
                      <img class="intergraImg" src="../../assets/img/morentupian.png" />
                    </div>
                  </el-image>
                    <div class="intergraName">
                      <el-tooltip effect="dark" :content="i.mallName || ''" placement="top">
                        <span class="goods-name">{{ i.mallName }}</span>
                      </el-tooltip>
                      <span class="enterprice-number" v-if="i.frequency">{{i.frequency}}人参与</span>
                    </div>
                    <div class="intergraName" style="color: #4f6efd">
                      <el-tooltip effect="dark" :content="i.mallDesc || ''" placement="top">
                        <span class="goods-price">{{ i.mallDesc }}</span>
                      </el-tooltip>
                      <span class="integral-count"><span class="integral-count-num">{{i.redeemPoints}}</span>积分</span>
                    </div>
                <el-button size="small" @click="toExchange(i)" class="exchangeBtn">立即兑换</el-button>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          background
          v-if="total > 0"
          style="text-align: right;margin-top: 10px"
          layout="total,prev, pager, next"
          :current-page="querySearch.pageNum"
          :page-size="querySearch.pageSize"
          :total="total"
          @current-change="selPageChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-card>
      <el-card style="margin: 30px 0" shadow="never">
        <el-tabs v-model="activeName" size="small" @tab-click="handleClick">
          <el-tab-pane name="first" label="发放记录">
            <el-table
              :data="dataList"
              style="width: 100%"
              :header-cell-style="{background:'#FFF3E3',color:'#FF8102'}"
            >
              <el-table-column prop="addDate" align="center" label="发放时间"></el-table-column>
              <el-table-column prop="obtainMethod" align="center" label="发放方式">
              </el-table-column>
              <el-table-column prop="issuePoints" align="center" label="发放积分"></el-table-column>
              <el-table-column prop="issueRemark" align="center" label="发放备注" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="我的礼品" name="second">
            <el-table
              :data="dataList"
              style="width: 100%"
              :header-cell-style="{background:'#FFF3E3',color:'#FF8102'}"
            >
              <el-table-column prop="addDate" align="center" label="兑换时间"></el-table-column>
              <el-table-column prop="mallId" align="center" label="兑换编号"></el-table-column>
              <el-table-column prop="mallName" align="center" label="礼品名称"></el-table-column>
              <el-table-column prop="number" align="center" label="消费积分"></el-table-column>
              <el-table-column label="兑换状态" prop="status" align="center">
                <template slot-scope="scope">
                  <el-button disabled v-if="scope.row.status == 1" style="color: #fff;background-color: #18A2FF;border: none;width: 80px;" type="primary" size="small" >待发放</el-button>
                  <el-button v-else-if="scope.row.status == 2" style="color: #FF7C18;background-color: #FFE9B7;border: none;width: 80px;" type="primary" size="small" @click="toExchangeInfo(scope.row)">查看奖品</el-button>
                  <el-button v-else-if="scope.row.status == 3" style="color: #ffffff;background-color: #CBC2C2;border: none;width: 80px;" type="primary" size="small">兑换失败</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <el-pagination
          background
          style="float: right;margin: 10px 0;"
          @size-change="handleSizeExchange"
          @current-change="handleCurrentExchange"
          :current-page.sync="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          layout="total, prev, pager, next"
          :total="exchangeTotal"
        ></el-pagination>
      </el-card>
    </div>
    <redeemNow v-if="redeemNowVisible" ref="redeemNow" @back="backList"></redeemNow>
    <!-- 积分规则 -->
    <el-card shadow="never" class="myTeam_card" v-if="pointsRules" style="height: calc(100vh - 200px);">
        <div slot="header" class="clearfix">
        <el-button type="text" class="backBtn" @click="backList">返回</el-button>
        <span class="font18">积分规则</span>
      </div>
      <div class="editorContent ql-snow ql-editor" v-html="rulesForm.dictValue"></div>
    </el-card>

     <!-- 积分兑换信息弹窗 -->
     <exchangeInfoDlg ref="exchangeInfoDlgRef"></exchangeInfoDlg>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getClient } from "@/plugins/auth";
import redeemNow from "./formPop/redeemNow";
import { myAssetsMoney, pointsMallList, pointsRecordList, getDicts, getPointsRecordClientList, getPointsExchangeClientList, exchangePointsClient, getPointsExchangeInfo } from "@/api/request";

import exchangeInfoDlg from "./formPop/exchangeInfoDlg";
export default {
  components: { redeemNow,exchangeInfoDlg},
  data() {
    return {
      userInfo: JSON.parse(getClient()),
      intergraList: [],
      redeemNowVisible: false,
      pointsRules: false,
      dataList: [],
      moneyInfo: {},
      activeName: "first",
      rulesForm: {
        dictValue: ""
      },
      imgurl: process.env.VUE_APP_FILE_API,
      exchangeTotal: 0,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        // queryType: 1
      },
      querySearch: {
        pageSize: 10,
        pageNum: 1,
        pointRange: '0,99999'
      },
      isExchanging: false,//是否兑换中
    };
  },
  computed: {
    ...mapGetters(["avatar", "name"])
  },
  mounted() {
    this.getMoney();
    this.getList();
    this.handleClick();
  },
  methods: {
    handleFilterChange() {
      this.querySearch.pageNum = 1;
      this.getList();
    },
    getMoney() {
      myAssetsMoney(this.userInfo.clientId).then(res => {
        this.moneyInfo = res.data;
      });
    },
    getList() {
      let params = {
        pageNum: this.querySearch.pageNum,
        pageSize: this.querySearch.pageSize,
        isAsc: 'desc',
        orderByColumn: 'sort',
        redeemPointsBegin: this.querySearch.pointRange.split(',')[0],
        redeemPointsEnd: this.querySearch.pointRange.split(',')[1]
      }
      pointsMallList(params).then(res => {
        this.intergraList = res.rows;
        this.total = res.total;
      });
    },
    // getExchangeList() {
    //   this.queryParams.clientId = this.userInfo.clientId;
    //   pointsRecordList(this.queryParams).then(res => {
    //     this.dataList = res.rows;
    //     this.exchangeTotal = res.total;
    //   });
    // },
    backList () {
        this.redeemNowVisible = false
        this.pointsRules = false
        this.getMoney();
        this.getList();
        this.queryParams.pageNum = 1;
        this.handleClick();
    },
    lookRules () {
      this.redeemNowVisible = false
      getDicts('point_rule').then(res=> {
        if (res && res.data && res.data.length > 0) {
            this.pointsRules = true
            this.rulesForm = res.data[0]
          }
        })
    },
    toExchangeInfo(item) {
      this.$refs.exchangeInfoDlgRef.publicOpen(item);
    },
    toExchange(item) {
      // if(this.userInfo.isFrozen === 1){
      //   return this.$message.warning(
      //     "您的积分已冻结，无法兑换，请联系客服"
      //   );
      // }
      // if (item.redeemPoints > this.moneyInfo.pointBalance) {
      //   return this.$message.warning(
      //     "当前剩余积分" + this.moneyInfo.pointBalance + "，无法兑换"
      //   );
      // }

      // 执行之前的积分校验后
      // 弹出确认弹窗
      // this.$refs.exchangeConfirmDlgRef.publicOpen(item);
      this.toInputeInfo(item);
    },
    toInputeInfo(item){
      // 填写信息操作改到 我的礼品里面
      // getPointsExchangeInfo(item.mallId).then(res => {
      //   if (res.code === 200 && res.data) {
          this.redeemNowVisible = true;
          this.$nextTick(()=> {
              this.$refs.redeemNow.init(item,this.moneyInfo,this.userInfo.clientId)
              window.scrollTo(0,0);
          })
        // }
      // });
    },
    confirmExchange(item) {
      // if(this.isExchanging){
      //   return;
      // }
      // this.isExchanging = true;
      // exchangePointsClient({mallId:item.mallId}).then(res => {
      //   if (res.code === 200) {
      //     this.$message.success("兑换成功");
      //     this.getMoney();
      //     this.handleClick();
      //   }
      // }).frequency(() => {
      //   this.isExchanging = false;
      // });
    },
    selPageChange(page) {
      this.querySearch.pageNum = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.querySearch.pageSize = val;
      this.getList();
    },
    handleCurrentExchange(page) {
      this.queryParams.pageNum = page;
      this.handleClick();
    },
    handleSizeExchange(val) {
      this.queryParams.pageSize = page;
      this.handleClick();
    },
    handleClick(tab, event) {
      this.dataList = [];
      if (this.activeName == "first") {
        this.requestGrantRecordList();
      } else {
        this.requestMyGiftsList();
      }
    },
    // 查询发放记录
    requestGrantRecordList(){
      getPointsRecordClientList({...this.queryParams,orderByColumn:'pointsId',isAsc:'desc'}).then(res => {
        this.dataList = res.rows;
        this.exchangeTotal = res.total;
      })
    },
    // 查询我的礼品
    requestMyGiftsList(){
      let params = {
        ...this.queryParams,
      }
      params.orderByColumn = 'id';
      params.isAsc = 'desc';
      getPointsExchangeClientList(params).then(res => {
        this.dataList = res.rows;
        this.exchangeTotal = res.total;
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.assets_top_box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.assets_top_left {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.assets_name {
  margin-bottom: 20px;
  font-size: 30px;
  font-weight: 500;
  color: #FF2E0C;
}
.gary{
  color: #B8B8B8 !important;
}
.assets_subname {
  font-size: 14px;
  font-weight: 500;
  color: #858585;
}
.assets-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.assets_right_name {
  font-size: 13px;
  font-weight: 600;
  color: #333333;
}
.assets_top_right {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  .assets_btn {
    background-color: #FDA533;
    color: #fff;
    border: none;
  }
}
.materialList{
  display: flex;
  flex: 1;
  width: 100%;
}
.custom-flex-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.custom-flex-item {
  width: 20%;
  display: flex;
}
.integral_equip_list {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  width: calc(100% - 15px);
  border: 1px solid #FCBA5D;
  border-radius: 10px;
  &:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  }
}

.intergraImg {
  width: 80%;
  height: auto;
  aspect-ratio: 1/1;
}
.intergraName {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px;
  width: 90%;
}
.goods-name {
  font-size: 16px;
  color: #FF8300;
  font-weight: bold;
  width: 50%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.enterprice-number {
  color: #999999;
  font-size: 13px;
  width: 40%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: right;
}
.goods-price{
  color: #828282;
  font-size: 13px;
  width: 50%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.integral-count{
  font-size: 14px;
  color: #141414;
  width: 100%;
  white-space: nowrap;
  text-align: right;
  text-overflow: ellipsis;
  overflow: hidden;
  .integral-count-num{
    color: #FF2E0C;
    font-size: 25px;
    margin-right: 3px;
    line-height: 1;
  }
}
.exchangeBtn {
  background: linear-gradient( 180deg, #FE944A 0%, #F87315 100%);
  color: #fff;
  border: none;
  width: 70%;
  margin-top: 8px;
}
.desciconLarge {
  background-color: #FBBF6A!important;
}
.backBtn {
  color: #fff;
  background-color: #FDA533;
  border: none;
  padding: 5px 20px!important;
}
</style>
<style lang="scss" scoped>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #FA7F29 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #FA7F29;
}
.el-tabs__item.is-active {
  color: #192E4D !important;
  font-weight: bold !important;
}
.el-tabs__active-bar {
  background-color: #FA7F29 !important;
  height: 3px !important;
}
.el-tabs__item:hover {
  color: #FA7F29 !important;
}
</style>
